import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import DeliveryMethodLabel from './DeliveryMethodLabel/DeliveryMethodLabel'

const DeliveryMethodSelector = ({ deliveryMethods = [], deliveryMethod, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      menuItems={deliveryMethods.map(deliveryMethod => ({
        label: <DeliveryMethodLabel deliveryMethod={deliveryMethod} />,
        value: deliveryMethod.id,
      }))}
      handleChange={onChange}
      value={deliveryMethod?.id}
      placeholder={t('Selecciona un nuevo método de devolución')}
    />
  )
}

export default DeliveryMethodSelector
